<template>
  <v-card
    :elevation="elevation"
    :style="{
      marginTop: '40px',
      width: table === 'email_templates' ? '100%' : '750px',
      maxWidth: table === 'email_templates' ? '100%' : '750px'
    }"
  >
<v-card-title>{{ title }}


</v-card-title>
  <v-simple-table>
    <template v-slot:default>

      <thead>
      <tr>
        <th
            v-for="value in values"
            :key="value.name"
            class="text-left">
          {{value.name}}
        </th>
        <th class="text-left">

        </th>
      </tr>

      <tr>
        <th

            v-for="value in values"
            :key="value.name"

            class="text-left">

          <v-text-field
              v-if='value.typ == "text" && value.name == "Stückzahl"'
              type="number"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
              autocomplete="false"
              :key="componentKey"
              v-model="form.parent_id[value.value]"
              outlined
          ></v-text-field>

          <v-text-field
              v-if='value.typ == "text" && value.name != "Stückzahl" && value.name != "E-Mail Inhalt"'
              type="search"
              autocomplete="false"
              :key="componentKey"
              v-model="form.parent_id[value.value]"
              outlined
          ></v-text-field>

          <v-textarea
              v-if='value.typ == "text" && value.name == "E-Mail Inhalt"'
              autocomplete="false"
              :key="componentKey"
              v-model="form.parent_id[value.value]"
              outlined
              rows="6"
              auto-grow
              placeholder="Geben Sie den E-Mail Inhalt ein..."
            
              persistent-hint
          ></v-textarea>

            <v-text-field
                v-if='value.typ == "color"'
                type="color"
                autocomplete="false"
                :key="componentKey"
                v-model="form.parent_id[value.value]"
                outlined
                style="min-width: 120px;"
            ></v-text-field>


          <CustomSelect
              v-if='value.typ == "select"'
              v-bind:table="value.select_table"
              v-bind:field_text="value.select_text"
              v-bind:field_value="value.select_value"
              v-bind:label="value.select_label"
              v-bind:selected="form.parent_id[value.value]"
              :key="componentKey"
              v-model="form.parent_id[value.value]"
          >

          </CustomSelect>
        </th>

        <th class="text-left">
          <v-btn
              v-if="id == ''"
              color="pink"
              fab
              dark
              small
              @click="addEntry()"

          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <v-btn
              v-if="id != ''"
              color="pink"
              fab
              dark
              small
              @click="addEntry()"

          >
            <v-icon>mdi-content-save</v-icon>
          </v-btn>

          <v-btn
              v-if="id != ''"
              color="pink"
              fab
              dark
              small
              @click="editEntryReset()"

          >
            <v-icon>mdi-cancel</v-icon>
          </v-btn>

        </th>
      </tr>

      </thead>

      <tbody

          v-if="data.length > 0">

      <tr
          v-for="item in data"
          :key="item.id"
      >
      <td
          v-for="value in values"
          :key="value.name"
          :style="{
            maxWidth: table === 'email_templates' && value.name === 'E-Mail Inhalt' ? 'none' : '350px',
            wordBreak: 'break-word'
          }"
      >
        <div 
          v-if="value.name === 'E-Mail Inhalt'" 
          style="white-space: pre-wrap; max-height: 200px; overflow-y: auto; padding: 8px; background: #f5f5f5; border-radius: 4px;"
          v-html="formatEmailContent(item[value.text] || item[value.value])"
        >
        </div>
        <p v-else>
          <span v-if="item[value.text] != '' && item[value.text] != undefined">{{ item[value.text] }}</span>
          <span v-else>{{ item[value.value] }}</span>
        </p>
      </td>


        <td>
          <div
              style="
              display: inline;
              white-space: nowrap;"
          >

          <v-icon

        @click="deleteData(item.id)"
        color="pink"
        style="padding:3px;"
        >mdi-delete-outline</v-icon>

          <v-icon style="padding: 3px;" v-if="editable == true" @click="editEntry(item.id)">mdi-pencil-outline</v-icon> <!--{{item.calories}}-->

          </div>
        </td>

      </tr>

      </tbody>

    </template>
  </v-simple-table>

  </v-card>
</template>

<script>



import CustomSelect from "@/components/CustomSelect";

export default {
  name: "GroupList",

  components:{
    CustomSelect,
  },

  data () {
    return {

      data: [],

      form: {
        parent_id: []
      },

      componentKey: '0',

      id: '',

      wasteno: ''

    }
  },


  async created() {


    await this.loadData()

   //  console.log(this.table)
   //  console.log(this.data.length)


    if(this.rest_qty != ""){
      this.form.parent_id["order_qty"] = this.rest_qty
    }

  },


  methods:{

    formatEmailContent(content) {
      if (!content) return '';
      return content.replace(/<br>/g, '\n');
    },

    preserveLineBreaks(fieldName) {
      if (this.form.parent_id[fieldName]) {
        this.form.parent_id[fieldName] = this.form.parent_id[fieldName];
      }
    },


    addEntry(){
      console.log("addEntry")
      this.saveData()
    },



    async loadData(){

      this.data = []

      // Einstellungen
      var param = {
        table: this.table,
        statement: "select",
        type: "list",
        where: "false",
        selector: "",
        value: "",
        short: "false", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "",
      }


      if(this.table == "group_tires"){
        param.extension = "ORDER BY name ASC"
      }




      if(this.temp_task_id != ""){
        param["where"] = "true"
        param["selector"] = "temp_task_id"
        param["value"] = this.temp_task_id

        console.log("temp_task_id !!!")
      }


      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)

      console.log("result")
      console.log(param)
      console.log(result)

      this.data = []

      this.$nextTick(() => {
        this.data = result
      });


    },

    async saveData(){

      this.componentKey += 1

      var statement
      if (this.id == ""){
        statement = "insert"
      }else{
        statement = "update"
      }

      // Parameter
      var param = {
        table: this.table,
        statement: statement,
        type: "",
        where: "true",
        selector: "id",
        value: this.id,
        short: "true", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "",
      }

      // Data
      var data = {}

      console.log("=== DEBUG: Starting saveData ===")

    
      for (var i1 = 0; i1 < this.values.length; i1++) {
        const field = this.values[i1]
        console.log(`Processing field: ${field.name} (${field.value}), type: ${field.typ}`)
        console.log(`Form value:`, this.form.parent_id[field.value])

        if(field.typ == "text" || field.typ == "color"){
          
          if(this.form.parent_id[field.value] == undefined){
            this.form.parent_id[field.value] = ""
          }

          if(field.name == "E-Mail Inhalt") {
            data[field.value] = this.form.parent_id[field.value].replace(/\n/g, '<br>')
          } else {
            data[field.value] = this.form.parent_id[field.value]
          }

          
          
          console.log(`Setting data[${field.value}] =`, data[field.value])

          if(field.required == true && this.form.parent_id[field.value] == ""){
            alert("Bitte " + field.name + " eingeben!")
            return
          }
          if(field.typ == "color" && this.form.parent_id[field.value] != ""){
            const colorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
            if(!colorRegex.test(this.form.parent_id[field.value])){
              alert("Bitte gültigen Hex-Farbcode eingeben (z.B. #FF0000)")
              return
            }
          }
        }

        if(field.typ == "select"){
          var test =  this.form.parent_id[field.value].split(";")
          data[field.value] = test[1]
          data[field.text] = test[0]
          console.log(`Select field - data[${field.value}] =`, data[field.value])
          console.log(`Select field - data[${field.text}] =`, data[field.text])

          if(field.required == true && test[1] == ""){
            alert("Bitte " + field.name + " eingeben!")
            return
          }
        }

        this.form.parent_id[field.value] = ""
      }

      data["temp_task_id"] = this.temp_task_id
      data["customer_id"] = this.customer_id
      data["group_type_id"] = this.group_type_id

      if (this.group_type_id == "" && this.table == "group_price"){
        data["group_type_id"] = await this.getGroupTypeId(data["group_type_name"])
      }

      console.log("Final data to be saved:", data)
      console.log("API parameters:", param)

      var result = await this.$func.queryAPI(param, data)
      console.log("API result:", result)

      this.$emit('items-changed')
      for (var i1 = 0; i1 < this.values.length; i1++) {
        this.form.parent_id[this.values[i1].value] = ""
      }

      this.id = ""
      this.loadData()
    },

    async getGroupTypeId(name){
      console.log("getGroupName: " + name)

      if(name == "" && name == undefined){
        return ""
      }

      // Einstellungen
      var param1 = {
        table: "group_type",
        statement: "select",
        type: "detail",
        where: "true",
        selector: "name",
        value: name,
        short: "false", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "",
      }

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data1 = {}
      var result1 = await this.$func.queryAPI(param1, data1)

      console.log(result1)

      if(result1.length == 0){
        return ""
      }

      return result1[0]["id"]




    },




    async editEntryReset(){

      this.id = ""

      for (var i2 = 0; i2 < this.values.length; i2++) {
        this.form.parent_id[this.values[i2].value] = ""
      }

      this.$nextTick(() => {

      });


      this.componentKey++

    },

    async editEntry(id){
      console.log("editEntry")
      console.log(id)

      this.id = id

      var param = {
        table: this.table,
        statement: "select",
        type: "detail",
        where: "true",
        selector: "id",
        value: this.id,
        short: "false", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "",
      }
      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {}
      var result = await this.$func.queryAPI(param, data)

      console.log("result:", result)

      this.values.forEach(value => {
        if (!this.form.parent_id.hasOwnProperty(value.value)) {
          this.form.parent_id[value.value] = ""
        }
      });

      for (var i2 = 0; i2 < this.values.length; i2++) {
        console.log(`Setting form.${this.values[i2].value} to:`, result[0][this.values[i2].value])
 
        if(this.values[i2].name === 'E-Mail Inhalt' && result[0][this.values[i2].value]) {
          this.form.parent_id[this.values[i2].value] = result[0][this.values[i2].value].replace(/<br>/g, '\n')
        } else {
          this.form.parent_id[this.values[i2].value] = result[0][this.values[i2].value] || ""
        }
      }
      
      this.$nextTick(() => {

      });
      this.componentKey++
    },

    async deleteData(id){

      if (confirm('Wirklich löschen?')) {
        // Save it!
        console.log('OK');
      } else {
        return
      }



      // Einstellungen
      var param = {
        table: this.table,
        statement: "delete",
        type: "detail",
        where: "true",
        selector: "id",
        value: id,
        short: "true", // Übermittlung nur von id
        // filter: "false",
        // filterfield: "",
        // filtervalue: "",
        // operator: "true",
        // Filter noch hinzufügen
        extension: "",
      }

      // Daten -> Werden nur bei Insert oder Update gesendet
      var data = {
      }

      var result = await this.$func.queryAPI(param, data)

      console.log(result)

      this.$emit('items-changed')

      this.loadData()


    },


  },


  props:{

    title: {
      type: String,
      default: 'Title'
    },

    table: String,

    editable: {
      type: Boolean,
      default: false
    },

    onlynumber: {
      type: Boolean,
      default: false,
    },

    temp_task_id: {
      type: String,
      default: "",
    },

    customer_id: {
      type: String,
      default: "",
    },

    group_type_id: {
      type: String,
      default: "",
    },

    values: [],

    elevation:{
      type: String,
      default: "2",
    },

    rest_qty:{
      type: String,
      default: "",
    }


  }


}
</script>

<style scoped>

</style>
